<template>
  <div>
    <!-- 试用申请弹框 -->
    <el-dialog :visible.sync="applyVisible" :close-on-click-modal="false" class="apply_dialog" @close="closeApply">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div class="ad_header">
          <img src="@/assets/img/index/icon/logo.jpg" />
          <span class="point"></span>
          <span class="ad_header_t">穗盈生鲜供应链系统</span>
        </div>
        <el-form-item label="您的姓名" prop="name" style="padding-top: 2.5rem;">
          <el-input placeholder="请输入姓名" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="tel">
          <el-input placeholder="请输入手机号码" v-model="ruleForm.tel"></el-input>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input placeholder="请输入企业名称" v-model="ruleForm.company"></el-input>
        </el-form-item>
        <el-form-item label="员工人数" prop="type" class="radio_len">
          <el-radio-group v-model="ruleForm.type" size="medium">
            <el-radio border label="0-20"></el-radio>
            <el-radio border label="21-50"></el-radio>
            <el-radio border label="51-100"></el-radio>
            <el-radio border label="100以上"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="sub">
          <el-button type="primary" @click="submitForm('ruleForm')" :disabled="!applyCheck">立即申请</el-button>
        </el-form-item>
        <div class="hot_tel">如有疑问，请拨打咨询热线：15920366002</div>
      </el-form>
    </el-dialog>
    <!-- 试用成功弹框 -->
    <el-dialog :visible.sync="successVisible" class="su_dialog">
      <img src="@/assets/img/index/icon/submitted_successfully.svg" class="logo" />
      <div class="title">提交成功</div>
      <div class="des">您的申请已提交成功！ </div>
      <div class="des">我们会安排专人联系您，请留意信息哦~ </div>
      <div class="des">感谢您对智慧农业的支持！</div>
      <el-button type="primary" @click="closeApplySuccess">我知道了</el-button>
      <div class="hot_tel">如有疑问，请拨打咨询热线：15920366002</div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data () {
    return {
      baseUrl: this.$baseUrl,
      applyVisible: false,
      // 申请成功弹框
      successVisible: false,
      ruleForm: {
        name: '',
        tel: '',
        company: '',
        type: '0-20'
      },
      // 校验
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          {min: 2, max: 5, message: '长度在 2 到 5 个字符', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'change'},
          {pattern: /^1[3|5|7|8|9]\d{9}$/, message: '请输入正确的号码格式', trigger: 'change'}
        ]
      }
    }
  },
  created () {},
  computed:{
    applyCheck() {
      const reg = /^1[3|5|7|8|9]\d{9}$/
      const { name, tel } = this.ruleForm
      if(name.length >= 2 && name.length<=5 && reg.test(tel)) return true
      else return false
    }
  },
  methods: {
    // 试用
    useClick () {
      this.applyVisible = true
      // this.closeApply()
    },
    // 清空申请值
    closeApply() {
      this.ruleForm.name = ''
      this.ruleForm.tel = ''
      this.ruleForm.company = ''
    },
    // dialog试用提交
    submitForm (formName) {
      let that = this
      let _name = ''
      that.$refs[formName].validate((valid) => {
        let _data = {
          name: that.ruleForm.name,
          phoneNum: that.ruleForm.tel,
          companyName: that.ruleForm.company,
          peopleNum: that.ruleForm.type,
          systemType: 1,
        }
        _name = _data.name
        if (valid) {
          const url = that.baseUrl + "/public/applySave"
          axios.get(url, { params: _data }).then(res=>{
            if (res.data.statusCode === 300) {
              that.$message.error(res.data.message);
            }
            if (res.data.statusCode === 200) {
              that.applyVisible = false
              that.successVisible = true
            }
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
      setTimeout( e=> {
        that.ruleForm.name = _name
      }, 500)
    },
    // 关闭成功弹框
    closeApplySuccess () {
      this.successVisible = false
      this.closeApply()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pc/components/apply.vue